import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import AuthPage from './pages/AuthPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import Dashboard from './pages/Dashboard'
import Analytics from './pages/Analytics'
import Releases from './pages/Releases'
import ArtistProfile from './pages/ArtistProfile'
import Community from './pages/Community'
import Settings from './pages/Settings'
import PremiumCheckout from './pages/PremiumCheckout'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import LegalNoticePage from './pages/LegalNoticePage'
import ContactPage from './pages/ContactPage'
import ProtectedRoute from './components/ProtectedRoute'
import DashboardLayout from './layouts/DashboardLayout'
import { ToastProvider } from './contexts/ToastContext'
import { ModalProvider } from './contexts/ModalContext'
import { UploadProvider } from './contexts/UploadContext'
import Toast from './components/Toast'


function App() {
  return (
    <ToastProvider>
        <UploadProvider>
          <ModalProvider>
            <Toast />
            <Router>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<AuthPage mode="login" />} />
                <Route path="/register" element={<AuthPage mode="register" />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route element={<ProtectedRoute />}>
                  <Route element={<DashboardLayout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/dashboard/analytics" element={<Analytics />} />
                    <Route path="/dashboard/releases" element={<Releases />} />
                    <Route path="/dashboard/community" element={<Community />} />
                    <Route path="/dashboard/settings" element={<Settings />} />
                    <Route path="/dashboard/premium" element={<PremiumCheckout />} />
                  </Route>
                </Route>
                <Route path="/artist/:slug" element={<ArtistProfile />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/legal" element={<LegalNoticePage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
            </Router>
          </ModalProvider>
        </UploadProvider>
      </ToastProvider>
  )
}


export default App
